import React from "react";
import { motion } from "framer-motion";

export default function Landing() {
  return (
    <motion.section
      className="min-h-[calc(100vh-60px)] flex items-center justify-center px-6 sm:px-8 py-16"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <figure className="relative w-full max-w-[860px] overflow-hidden">
        <img
          src="/photos/IMG_1695.jpeg"
          alt=""
          className="w-full h-auto block"
          style={{ aspectRatio: "4 / 3" }}
        />
      </figure>
    </motion.section>
  );
}
